import React from "react";
import Button from "react-bootstrap/Button";
import DropdownButton from "react-bootstrap/DropdownButton";
import Dropdown from "react-bootstrap/Dropdown";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';

function NavbarCategories() {
  const { t } = useTranslation();

  const categories = [
    // Grupo Food
    { path: "/category/bebidas", label: t('menu_drinks'), group: "food" },
    { path: "/category/biscoitos-e-snacks", label: t('menu_snacks'), group: "food" },
    { path: "/category/carnes-a-vacuo", label: t('menu_meat'), group: "food" },
    { path: "/category/cereais-e-misturas", label: t('menu_cereals'), group: "food" },
    { path: "/category/doces-e-guloseimas", label: t('menu_sweets'), group: "food" },
    { path: "/category/graos-e-farinaceos", label: t('menu_grains'), group: "food" },
    { path: "/category/oleos-e-azeites", label: t('menu_oils'), group: "food" },
    { path: "/category/temperos-e-condimentos", label: t('menu_spices'), group: "food" },
    { path: "/category/utensilios", label: t('menu_utensils'), group: "food" },

    // Grupo Care
    { path: "/category/cabelos", label: t('menu_hair') },
    { path: "/category/cuidados-com-a-pele", label: t('menu_skin_care'), group: "care" },
    { path: "/category/cuidados-faciais", label: t('menu_facial_care'), group: "care" },
    { path: "/category/cuidados-com-a-barba", label: t('menu_beard'), group: "care" },

    // Demais categorias
    { path: "/category/oleos-perfumados", label: t('menu_fragrant_oils') },
    { path: "/category/perfumaria", label: t('menu_perfumery') },
    { path: "/category/sabonete", label: t('menu_soaps') },
    { path: "/category/maquiagem", label: t('menu_makeup') },
    { path: "/category/infantil", label: t('menu_children') },
    { path: "/category/gifts", label: t('menu_gifts') },
  ];

  // Ordem de prioridade dos grupos
  const groupOrder = ["food", "care", "outros"];

  // Ordena por grupo (prioridade) e, dentro do grupo, por label
  const allSorted = [...categories].sort((a, b) => {
    const groupA = a.group || "outros";
    const groupB = b.group || "outros";

    const orderDiff = groupOrder.indexOf(groupA) - groupOrder.indexOf(groupB);
    if (orderDiff !== 0) return orderDiff;

    return a.label.localeCompare(b.label, 'pt-BR', { sensitivity: 'base' });
  });

  const careGroup = allSorted.filter(cat => cat.group === "care");
  const foodGroup = allSorted.filter(cat => cat.group === "food");

  return (
    <>
      {/* Desktop */}
      <ButtonGroup className="d-none d-xl-flex">
        {allSorted.map((cat, index) => {
          // Grupo Food
          if (cat.group === "food") {
            if (index === allSorted.findIndex(c => c.group === "food")) {
              return (
                <DropdownButton
                  key="food-group"
                  as={ButtonGroup}
                  title={t('menu_food')}
                  id="dropdown-food"
                  variant="primary"
                  className="food-item"
                >
                  {foodGroup.map((c, i) => (
                    <Dropdown.Item key={i} as={Link} to={c.path}>
                      {c.label}
                    </Dropdown.Item>
                  ))}
                </DropdownButton>
              );
            }
            return null;
          }

          // Grupo Care
          if (cat.group === "care") {
            if (index === allSorted.findIndex(c => c.group === "care")) {
              return (
                <DropdownButton
                  key="care-group"
                  as={ButtonGroup}
                  title={t('menu_care')}
                  id="dropdown-care"
                  variant="primary"
                  className="food-item"
                >
                  {careGroup.map((c, i) => (
                    <Dropdown.Item key={i} as={Link} to={c.path}>
                      {c.label}
                    </Dropdown.Item>
                  ))}
                </DropdownButton>
              );
            }
            return null;
          }

          // Categorias normais
          return (
            <Button key={index} as={Link} to={cat.path} className="bt_nav_categories">
              {cat.label}
            </Button>
          );
        })}
      </ButtonGroup>

      
      {/* Mobile */}
      <DropdownButton
        title='Menu'
        id="dropdown-categories"
        className="mt-1 d-xl-none"
      >
        {allSorted.map((cat, index) => (
          <Dropdown.Item
            key={index}
            as={Link}
            to={cat.path}
            eventKey={index + 1}
            className={cat.group === "food" ? "food-item" : ""}
          >
            {cat.label}
          </Dropdown.Item>
        ))}
      </DropdownButton>

    </>
  );
}

export default NavbarCategories;
